import { getEnumValues } from './get-enum-values';
export enum AthleteMetric{
	Power='power',
	Acceleration='acceleration',
	Speed='speed',
	Agility='agility',
	Recovery='recovery',
}
export const AthleteMetricValues = getEnumValues<AthleteMetric>(AthleteMetric);